import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { InvoiceService } from '../services/invoice.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

const ROUTES_ALLOWED_WHEN_BLOCKED = ['', '/', '/invoices', '/login', '/forgot-password', '/reset-password'];

function isRouteAllowedWhenBlocked(url: string): boolean {
  if (url === '' || url === '/') return true;
  return ROUTES_ALLOWED_WHEN_BLOCKED.some(allowed => {
    if (allowed === '' || allowed === '/') return false;
    return url === allowed || url.startsWith(allowed + '/');
  });
}

/**
 * Guard que bloqueia acesso quando há fatura vencida há mais de 7 dias (blockAccess da API).
 * Quando bloqueado, permite apenas: /, /invoices, /login, /forgot-password, /reset-password.
 */
export const overdueBlockGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const invoiceService = inject(InvoiceService);

  if (typeof window === 'undefined' || !window.localStorage) {
    return true;
  }

  const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
  if (!token) {
    return true;
  }

  const url = state.url.split('?')[0];
  const isAllowedRoute = isRouteAllowedWhenBlocked(url);

  return invoiceService.getOverdueInvoices().pipe(
    map(response => {
      const blockAccess = response.blockAccess === true;
      if (blockAccess && !isAllowedRoute) {
        return router.createUrlTree(['/invoices']);
      }
      return true;
    }),
    catchError(() => {
      return of(true);
    })
  );
};
